'use client';

import { useSession } from 'next-auth/react';

interface PriceResult {
  displayPrice: number | null;
  displaySalesPrice: number | null;
  isNetPrice: boolean;
}

export function useProductPrice(price: number | null | undefined, salesPrice: number | null | undefined, taxRate: number = 23): PriceResult {
  const { data: session } = useSession();
  const isB2B = (session?.user as any)?.type === 'b2b';

  if (isB2B) {
    const divisor = 1 + taxRate / 100;
    return {
      displayPrice: price != null ? price / divisor : null,
      displaySalesPrice: salesPrice != null ? salesPrice / divisor : null,
      isNetPrice: true,
    };
  }

  return {
    displayPrice: price ?? null,
    displaySalesPrice: salesPrice ?? null,
    isNetPrice: false,
  };
}
